<template>
  <div
:id="vnodeId" ref="subGridWrapper" :class="classes" @click="onClick"
       @mouseenter="mouseOverAction" @mouseleave="mouseLeaveAction">
    <div :class="bgImageColor1" />
    <div :class="bgImageColor2" />

    <drag-items
      class="sub-drag-item"
      :exclude-item="['container']"
      :vnode-id="vnodeId"
      :view-mode="viewMode"
      widget-class="grid-stack-item-sub"
    />

    <img
      v-show="fbNode.children.length === 0 && !backgroundImgExist"
      class="img-fluid shadow-none img-radius-none"
      style="position: absolute; top: 0; left: 0; padding: 18px 10px"
      src="/img/box-container-placeholder-.svg"
      alt=""
    />
    <div class="w-100">
      <div
          :id="`${vnodeId}-sub-grid`"
          ref="gridRootWrapper" class="position-relative sub-grid-visual-box">
<!--        box-color="#c2bebe8f"-->
        <visual-box
            ref="vsBox"
            box-color="#333333"
            :grid-column="column"
            :grid-column-height="cellHeight"
            :grid-v-node-id="`${vnodeId}-sub-grid`"/>
        <div
            ref="nestedGridStackElement"
            :style="fontColorBG"
            class="grid-stack"
        >
          <template v-for="node in fbNode.children">
            <grid-item-v3
                :key="node.data.props.vnodeId"
                :fb-node="node"
                v-bind="node.data.props"
                @removeElement="removeNode"
                @duplicateElement="duplicateNode"
                @forceRemoveElement="forceRemoveNode"
            >
            </grid-item-v3>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AddCommand } from '../../../../commands/AddCommand'
import SubGridContainer from '../../../editor/nodes/SubgridContainer/script.ts'
import FirebaseNodeV3 from '../../base/FirebaseNode'
import GridBuilderMixin from '../../base/GridBuilderMixin'

export default SubGridContainer.extend({
  name: 'SubGridContainerV3',
  mixins: [FirebaseNodeV3, GridBuilderMixin],

  computed: {
    backgroundImgExist() {
      return (
        this.fbNode?.data?.props?.background?.image != null &&
        this.fbNode?.data?.props?.background?.image !== ''
      )
    },
  },
  mounted() {
    // this.$nextTick(()=> {
    //   this.resizeObserver = new ResizeObserver(entries =>
    //       this.heightChanged(entries[0].target)
    //   )
    //   this.resizeObserver.observe(this.$el)
    // })
  },
  methods: {
    heightChanged (target) {
      if (target?.clientHeight && this.getGrid()) {
        // console.log('heightChanged: ', target?.clientHeight)
        // this.getGrid().maxHeight(target?.clientHeight)
        // this.getGrid().minHeight(target?.clientHeight)
      }
    },
    getGrid() {
      return this.$refs.nestedGridStackElement.gridstack
    },
    addGridItem(vNode, options) {
      if (['grid-box-container', 'sub-grid-container'].includes(vNode.tag)) {
        return
      }
      if (['c-form'].includes(vNode.tag)) {
        this.setPageId(vNode)
      }
      let widget = this.wrapInGridItemWrapper(vNode, options)
      this.pushCommand(new AddCommand(this, widget))
    },
    reloadContent() {
      const children = [...this.$refs.nestedGridStackElement.children]
      children.forEach((child) => {
        this.makeWidget(child)
      })
    },
    registerObserver() {

    },
    mouseOverAction (event) {
      this.$parent.$parent.$el.classList.add('hide-grid-lines')
      this.$refs.vsBox.$el.classList.add('show-grid')
    },
    mouseLeaveAction (event) {
      this.$parent.$parent.$el.classList.remove('hide-grid-lines')
      this.$refs.vsBox.$el.classList.remove('show-grid')
    },
  },
})
</script>
